import React, { createContext, useContext, useEffect, useState } from "react";
import { CheckIfLoggedIn } from "../BackendAccess/UserHooks";
import { useLocation } from "react-router-dom";

const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const location = useLocation();
  const refreshLoginStatus = async () => {
    const [data, error] = await CheckIfLoggedIn();
    setLoggedIn(!error && data);
  };

  useEffect(() => {
    refreshLoginStatus();
  }, [location.pathname]);

  return (
    <LoginContext.Provider
      value={{ loggedIn, setLoggedIn, refreshLoginStatus }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export const useLogin = () => useContext(LoginContext);
